import { useEffect, useState } from 'react';
import { functions } from 'lib/firebase';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { commandsErrorsAtom, instanceIdAtom, pinAtom, tokenAtom } from './globalState';

const sendCommand = functions.httpsCallable('areax_sendCommand');

export const commands = ['PIACERE_PEPPER', 'DOPO_SITO', 'DOPO_PRENOTAZIONE', 'SCEGLI_PROSEGUO', 'CIAO_STATO_PIACER', 'DANCE', 'SWAG', 'ESULTANZA', 'SELFIE', undefined];

type CommandType = typeof commands[number]

interface UseRemoteOptions {
	command: CommandType,
	instanceId?: string;
	pin?: number
}

const useRemote = ({ command, instanceId, pin }: UseRemoteOptions) => {
	const [result, setResult] = useState<undefined | any>();
	const instanceIDState = useRecoilValue(instanceIdAtom);
	const pinState = useRecoilValue(pinAtom);
	const setCommandErrors = useSetRecoilState(commandsErrorsAtom);
	const [token, setToken] = useRecoilState(tokenAtom);

	useEffect(() => {
		if (!command)
			return;
		const localPin = pin || pinState;
		const localInstanceId = instanceId || instanceIDState;
		if (localInstanceId && localPin && token){
			sendCommand({
				command,
				instanceId: localInstanceId,
				pin: localPin
			})
			.then((res) => {
					console.log('useRemote::', { command, localInstanceId, localPin }, res.data);
					setResult(res.data);
					if (res.data.error){
						setCommandErrors(prev => prev + 1);
						setToken(undefined);
					}
				}
			);
		} else {
			console.log('useRemote:: invalid params or token', command, localInstanceId, localPin);
		}
	}, []);

	return { result };
};

const useLazyRemote = ({ command, instanceId, pin }: UseRemoteOptions) => {
	const [result, setResult] = useState<undefined | any>();
	const instanceIDState = useRecoilValue(instanceIdAtom);
	const pinState = useRecoilValue(pinAtom);
	const setCommandErrors = useSetRecoilState(commandsErrorsAtom);

	const runCommand = () => {
		if (!command)
			return;
		const localPin = pin || pinState;
		const localInstanceId = instanceId || instanceIDState;
		if (localInstanceId && localPin){
			sendCommand({
				command,
				instanceId: localInstanceId,
				pin: localPin
			})
			.then((res) => {
					if (res.data.error){
						setCommandErrors(prev => prev + 1);

						setResult(res.data);
					}
				}
			);
		} else {
			console.log('useLazyRemote:: invalid params', command, localInstanceId, localPin);
		}
	};

	return { result, runCommand };
};

export default useRemote;

export { useLazyRemote, useRemote };